import {
	GuardedType,
	isArray,
	IsInterface,
	isSingletonString,
	isSingletonStringUnion,
	isString,
	TypeGuard
} from "generic-type-guard";

import { Notification } from "@com.mgmtp.a12.client/client-core/lib/core/notification";

import { isBoolean } from "../utilities/typeGuardUtils";

import { isLocalizable } from "./localizable";

export interface BaseNotification extends Omit<Notification, "id" | "duration" | "position" | "componentId"> {
	readonly group?: string;
}

export const isBaseNotification: TypeGuard<BaseNotification> = new IsInterface()
	.withOptionalProperties({
		title: isLocalizable,
		message: isLocalizable,
		activityId: isString,
		severity: isSingletonStringUnion("info", "success", "warning", "error"),
		icon: isString,
		group: isString
	})
	.get();

export const isNotificationWithButton = new IsInterface()
	.with(isBaseNotification)
	.withProperties({
		componentId: isSingletonString("NotificationWithButton"),
		activityId: isString,
		button: new IsInterface()
			.withProperties({
				label: isLocalizable,
				action: new IsInterface()
					.withProperties({ type: isString })
					.withOptionalProperty(
						"payload",
						new IsInterface()
							.withOptionalProperties({ docRef: isString, initiatingActivityId: isString })
							.get()
					)
					.get()
			})
			.withOptionalProperties({ destructive: isBoolean })
			.get()
	})
	.get();

export type NotificationWithButton = GuardedType<typeof isNotificationWithButton>;

export const isNotificationWithList = new IsInterface()
	.with(isBaseNotification)
	.withProperties({
		componentId: isSingletonString("NotificationWithList"),
		items: isArray(isString)
	})
	.get();

export type NotificationWithList = GuardedType<typeof isNotificationWithList>;

export type CustomNotification = BaseNotification | NotificationWithButton | NotificationWithList;
